import React, { useEffect, useState } from "react";
import { api, assetUrl } from "@/lib/api";
import Seo from "@/components/Seo";

export default function About() {
  const [a, setA] = useState({});
  useEffect(() => { api.get("/content/about").then((r) => setA(r.data?.data || {})); }, []);
  return (
    <div>
      <Seo title={a.title || "About Crochet Kerry"} description={a.intro} image={assetUrl(a.image)} />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        <div>
          <p className="text-xs uppercase tracking-luxe text-brand-pink mb-3">Our story</p>
          <h1 className="font-serif-display text-4xl sm:text-5xl mb-5">{a.title}</h1>
          <p className="text-lg text-muted-foreground mb-4 font-light">{a.intro}</p>
          {(a.body || "").split("\n\n").map((p, i) => <p key={i} className="text-muted-foreground leading-relaxed mb-4">{p}</p>)}
        </div>
        <div className="h-[520px] overflow-hidden rounded-sm"><img src={assetUrl(a.image)} alt={a.title} className="w-full h-full object-cover" /></div>
      </section>
    </div>
  );
}
